module.exports = __webpack_public_path__ + "img/6522.01b9de84.jpg";